import { create } from "zustand"
import { HeightRestrictionFeatureCollection } from "../../services/OgcService/models/HeightRestrictionFeatureCollection";

export interface IHeightRestrictionActions {
    setHeightRestrictions: (feature: HeightRestrictionFeatureCollection | null ) => void;
    setIsLoading: (isLoading : boolean) => void;
    setCurrentHeight: (currentHeight: number) => void;
}

export interface IHeightRestrictionState{
    heightrestrictions: HeightRestrictionFeatureCollection | null,
    isLoading : boolean;
    currentHeight: number;
    actions: IHeightRestrictionActions;
}

const useHeightRestrictionStore = create<IHeightRestrictionState>( (set) => ({
    heightrestrictions: null,
    setHeightRestrictions: (heightrestrictions: HeightRestrictionFeatureCollection | null) => {
        set({heightrestrictions: heightrestrictions});
    },
    isLoading: false,
    setIsLoading: (isLoading : boolean) => {
        set({isLoading : isLoading})
    },
    currentHeight: 4.5,
    setCurrentHeight: (currentHeight: number) => {
        set({currentHeight: currentHeight});
    },
    actions: {
        setHeightRestrictions: (heightrestrictions: HeightRestrictionFeatureCollection | null) => {
            set({heightrestrictions: heightrestrictions});
        },
        setIsLoading: (isLoading : boolean) => {
            set({isLoading : isLoading})
        },
        setCurrentHeight: (currentHeight: number) => {
            set({currentHeight: currentHeight});
        }
    }
}));

export const useHeightRestrictions = () => useHeightRestrictionStore((state) => state.heightrestrictions);
export const useHeightRestrictionIsLoading = () => useHeightRestrictionStore((state) => state.isLoading);
export const useCurrentHeight = () => useHeightRestrictionStore((state) => state.currentHeight);
export const useHeightRestrictionActions = () => useHeightRestrictionStore((state) => state.actions);
